export default __webpack_public_path__ + "static/media/fuel-main-meter-icon.dd917c5f.svg";